import { render, staticRenderFns } from "./UpdateWatercraftType.vue?vue&type=template&id=200c7f0b"
import script from "./UpdateWatercraftType.vue?vue&type=script&lang=ts"
export * from "./UpdateWatercraftType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports